export enum WaiverStatusTypeEnums {
    None = 0,
    Pending = 1,
    Processed = 2
}
